import { WizardSubmitHandler }     from '../WizardSubmitHandler'
import { WizardPrevHandler }       from '../WizardPrevHandler'
import { OnSchedOnChange }         from '../../OnSchedOnChange'
import { OnSchedTemplates } from '../../../OnSchedTemplates'
import { UpdateBusinessHoursTime } from '../UpdateBusinessHoursTime'
import { InitSelectDomElements } from './InitSelectDomElements'


export const InitWizardDomElements = (element, timezoneData) => {
  const el = document.getElementById(element.id);

  // Initialize DOM elements now that we have loaded the template

  // Initialize the steps from looking at DOM Sections loaded
  var elWizardSections = document.querySelectorAll(".onsched-wizard-section");
  var elWizardNavStatus = document.querySelector(".onsched-wizard-nav-status");

  var wizardSections = [];
  for (var i=0; i < elWizardSections.length; i++) {
      var elWizardSection = elWizardSections[i];
      var sectionStyle = window.getComputedStyle(elWizardSection)
      wizardSections.push(sectionStyle.display);
  }
  elWizardNavStatus.innerHTML = OnSchedTemplates.wizardSteps(wizardSections);

  var elWizardForm = document.querySelector(".onsched-wizard.onsched-form");
  elWizardForm.addEventListener("submit", (event) => WizardSubmitHandler(event, element));
  var elPrevButton = document.querySelector(".onsched-wizard-nav-buttons .prevButton");
  elPrevButton.addEventListener("click", WizardPrevHandler);
  
  var elTimezone = document.getElementById('onsched-timezone');
  
  var toggleTimezoneDropdown = e => {
    if (e.target.dataset.tztoggle !== 'false') {
      elTimezone.classList.toggle('active');
    }
  }

  InitSelectDomElements(element, timezoneData);

  // This click handler focuses on actions for the business hours, and availability hours.
  // A click will either hide or show a dropdown menu

  document.querySelectorAll(`[data-day="sun"]`).forEach(elDaySelected => elDaySelected.classList.add('selected'))

  const toggleSelected = daySelected => {
    document.querySelectorAll('.onsched-business-hours-day.selected').forEach(day => day.classList.remove('selected'))
    document.querySelectorAll('.onsched-business-hours-time.selected').forEach(time => time.classList.remove('selected'))
    document.querySelectorAll('.onsched-business-hours-row.available .onsched-dropdown-menu.selected').forEach(menu => menu.classList.remove('selected'))
    document.querySelectorAll('.onsched-business-hours-row.available .onsched-select.selected').forEach(menu => menu.classList.remove('selected'))
    document.querySelectorAll(`[data-day="${daySelected}"]`).forEach(elDaySelected => elDaySelected.classList.add('selected'))
  }

  elWizardForm.addEventListener("change", function (event) {
    if (event.target.classList.contains('onsched-dropdown-menu')) {
      let targetValue = event.target.value.toLowerCase().replace(' ', '');
      if (targetValue === '24hours') targetValue = 'hrs24'
      if (targetValue === '24hrs') targetValue = 'hrs24'
      let targetDay = event.target.dataset.day;
      document.querySelectorAll(`.onsched-business-hours-time.${targetDay}`)
        .forEach(
          timeDropdown => timeDropdown.children.forEach(c => {
            if (!c.classList.contains('hide')) {
              c.classList.toggle('hide');
            }
            if (c.classList.contains(targetValue)) {
              c.classList.toggle('hide');

              switch(targetValue) {
                case 'open':
                  document.querySelectorAll(`[data-day="${targetDay}"] .time.open`)
                    .forEach(t => {
                      t.dataset.isopen = true;
                      t.dataset.is24hours = false;
                    })
                  break;
                
                case 'hrs24':
                  document.querySelectorAll(`[data-day="${targetDay}"] .time.open`)
                    .forEach(t => {
                      t.dataset.isopen = true;
                      t.dataset.is24hours = true;
                    })
                  break;
                  
                default:
                  document.querySelectorAll(`[data-day="${targetDay}"] .time.open`)
                    .forEach(t => {
                      t.dataset.isopen = false;
                      t.dataset.is24hours = false;
                    })
                  break;
              }
            }
          })
        )
    }
  })
  elWizardForm.addEventListener("click", function (event) {
    if (document.getElementById('onsched-timezone')?.classList.contains('active') && 

        !event.target.classList.contains('onsched-timezone-button')) {
          event.preventDefault();
      toggleTimezoneDropdown(event);
    }
    if (event.target.classList.contains("fa-angle-down")) {
        event.target.parentElement.classList.toggle('active');
    }
    if (event.target.classList.contains("onsched-business-hours-day")) {
      if (!event.target.classList.contains('selected')) {
        let daySelected = [...event.target.classList].filter(dayClass => dayClass !== 'onsched-business-hours-day')[0];
        toggleSelected(daySelected)
      }
    }
    if (event.target.classList.contains("short") ||
    event.target.classList.contains("long")
    ) {
      if (!event.target.parentElement.classList.contains('selected')) {
        let daySelected = [...event.target.parentElement.classList].filter(dayClass => dayClass !== 'onsched-business-hours-day')[0];
        toggleSelected(daySelected)
      }
    }
  }, false); // end of onclick processing
}
